module.exports = __webpack_public_path__ + "img/eye.ccef8e77.svg";